import dayjs from "dayjs";
import React, { FC, useState } from "react";
import { TaskExecution } from "shared/api/task-hub-execution";
import { Spin } from "antd";
import { EditOutlined } from "@ant-design/icons";
import { StatusEditModal } from "pages/ProductCards/ProductCards/ui/TaskHub/StatusEditModal";
import { MessageEditModal } from "pages/ProductCards/ProductCards/ui/TaskHub/MessageEditModal";

interface MaintenanceTableProps {
  statusModalOpen?: boolean;
  setStatusModalOpen?: React.Dispatch<React.SetStateAction<boolean>>;
  isMessageModalOpen?: boolean;
  setIsMessageModalOpen?: React.Dispatch<React.SetStateAction<boolean>>;
  tasksExecution?: TaskExecution[];
  isLoading?: boolean;
  isFetching?: boolean;
}

export const MaintenanceTable: FC<MaintenanceTableProps> = ({
  setStatusModalOpen,
  statusModalOpen,
  isMessageModalOpen,
  setIsMessageModalOpen,
  tasksExecution,
  isLoading,
  isFetching,
}) => {
  const [selectedTask, setSelectedTask] = useState<TaskExecution | null>(null);

  const openStatusModal = (task: TaskExecution) => {
    setSelectedTask(task);
    setStatusModalOpen?.(true);
  };

  const openMessageModal = (task: TaskExecution) => {
    setSelectedTask(task);
    setIsMessageModalOpen?.(true);
  };

  const loading = isLoading || isFetching;

  return (
    <>
      <div className="relative">
        {loading ? (
          <div className="absolute inset-0 z-10 flex items-center justify-center bg-black bg-opacity-30">
            <Spin size="large" />
          </div>
        ) : (
          <div className={`overflow-x-auto p-1 ${loading ? "opacity-30" : ""}`}>
            <div className="max-h-[450px] overflow-y-auto">
              <table className="min-w-full border-collapse border border-gray-400 text-lg">
                <thead className="bg-blue-900 text-white">
                  <tr>
                    <th className="border px-6 py-4 text-center">Expected</th>
                    <th className="border px-6 py-4 text-center">Task Name</th>
                    <th className="border px-6 py-4 text-center">Username</th>
                    <th className="border px-6 py-4 text-center">Executed</th>
                    <th className="border px-6 py-4 text-center">Message</th>
                    <th className="border px-6 py-4 text-center">Priority</th>
                    <th className="border px-6 py-4 text-center">Status</th>
                  </tr>
                </thead>
                <tbody>
                  {tasksExecution?.map((task) => (
                    <tr
                      key={task.id}
                      className="bg-gray-200 hover:bg-gray-300 text-center"
                    >
                      <td className="border px-6 py-4">
                        {dayjs(task.timestamp_expected).format(
                          "YYYY-MM-DD HH:mm"
                        )}
                      </td>
                      <td className="border px-6 py-4">
                        {task.task.name ?? "-"}
                      </td>
                      <td className="border px-6 py-4">
                        {typeof task.user === "object" && task.user?.username
                          ? task.user.username
                          : "-"}
                      </td>
                      <td className="border px-6 py-4">
                        {task.timestamp_executed
                          ? dayjs(task.timestamp_executed).format(
                              "YYYY-MM-DD HH:mm"
                            )
                          : "-"}
                      </td>
                      <td className="border px-6 py-4">
                        <div className="flex items-center justify-center gap-2">
                          {task.message ?? "-"}
                          <EditOutlined
                            className="cursor-pointer text-blue-600"
                            onClick={() => openMessageModal(task)}
                          />
                        </div>
                      </td>
                      <td className="border px-6 py-4">{task.priority}</td>
                      <td className="border px-6 py-4">
                        <div className="flex items-center justify-center gap-2">
                          {task.status ?? "-"}
                          <EditOutlined
                            className="cursor-pointer text-blue-600"
                            onClick={() => openStatusModal(task)}
                          />
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>

      <StatusEditModal
        open={statusModalOpen || false}
        record={selectedTask}
        onClose={
          setStatusModalOpen ? () => setStatusModalOpen(false) : () => {}
        }
      />

      <MessageEditModal
        open={isMessageModalOpen || false}
        record={selectedTask}
        onClose={
          setIsMessageModalOpen ? () => setIsMessageModalOpen(false) : () => {}
        }
      />
    </>
  );
};
